import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-truck-site-summary-report',
	templateUrl: './truck-site-summary-report.component.html',
	styleUrls: ['./truck-site-summary-report.component.css']
})
export class TruckSiteSummaryReportComponent {

	@Input() siteInfo!: any;
	@Input() selectedPeriodFormatted!: any;
	@Input() period!: any;
	@Input() selectedDays!: any;
	@Input() data!: any;
	@Input() totalTrucks: number = 0;
}
